module.exports = __webpack_public_path__ + "img/wenli-2.84bce0ae.png";